<script>
import ElEmpty from 'element-ui/lib/empty'

export default {
  name: 'ElEmpty',
  extends: ElEmpty,
  render (h) {
    const vnode = ElEmpty.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-empty']
    return vnode
  }
}
</script>
